// 引用 Mock
const Mock = require('mockjs')
const Random = Mock.Random
 
const illustInfo = Mock.mock("/recomend", "get", {
  // 属性 list 的值是一个数组，随机生成 1 到 10 个元素
  "list|1-10": [
    {
      // 随机生成1-10个★
      "title": "title",
      "user": "user",
      "url": Random.image(),
      
      
    },
  ],
  code: 200,
  message: 'ok',
});

const tageList = Mock.mock("/tage","get", {
  "tagL|10":[
    "tag"
  ]
});

export default {illustInfo, tageList}